<!--Changing Weapon Material-->
<div class="list-item" *ngIf="(item.moddable && !get_IsUnarmored(item)) || customItemStore">
    <ng-container *ngIf="item.material && item.constructor.name === 'Armor'">
        <div class="newrow">
            <strong>Material</strong>
            <select [(ngModel)]="newArmorMaterial[0]" (ngModelChange)="add_ArmorMaterial()">
                <ng-container
                    *ngFor="let material of get_InitialArmorMaterials(); let initialRuneIndex = index; trackBy:trackByIndex;">
                    <option [ngValue]="material" *ngIf="initialRuneIndex === 0" [selected]=!item.material[0]>
                        <!--Blank option to deselect-->
                    </option>
                    <optgroup *ngIf="initialRuneIndex === 1" label="Current material">
                        <option [ngValue]="material">
                            {{material.material.name}}
                        </option>
                    </optgroup>
                </ng-container>
                <optgroup label="Available materials" *ngIf="get_ArmorMaterials().length">
                    <option *ngFor="let material of get_ArmorMaterials(); trackBy:trackByIndex;" [ngValue]="material"
                        [disabled]="material.disabled" title="{{get_Title(material.material)}}">
                        {{material.material.name}}
                    </option>
                </optgroup>
            </select>
        </div>
        <ng-container *ngIf="craftingStation">
            <ng-container *ngFor="let material of item.material; trackBy:trackByIndex;">
                <div class="newrow" *ngIf="material.craftRequirement">
                    <span>
                        <strong>Craft Requirement&nbsp;</strong>
                        <span>{{material.craftRequirement}}</span>
                    </span>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="item.material && item.constructor.name === 'Shield'">
        <div class="newrow">
            <strong>Material</strong>
            <select [(ngModel)]="newShieldMaterial[0]" (ngModelChange)="add_ShieldMaterial()">
                <ng-container
                    *ngFor="let material of get_InitialShieldMaterials(); let initialRuneIndex = index; trackBy:trackByIndex;">
                    <option [ngValue]="material" *ngIf="initialRuneIndex === 0" [selected]=!item.material[0]>
                        <!--Blank option to deselect-->
                    </option>
                    <optgroup *ngIf="initialRuneIndex === 1" label="Current material">
                        <option [ngValue]="material">
                            {{material.material.name}}
                        </option>
                    </optgroup>
                </ng-container>
                <optgroup label="Available materials" *ngIf="get_ShieldMaterials().length">
                    <option *ngFor="let material of get_ShieldMaterials(); trackBy:trackByIndex;" [ngValue]="material"
                        [disabled]="material.disabled" title="{{get_Title(material.material)}}">
                        {{material.material.name}}
                    </option>
                </optgroup>
            </select>
        </div>
        <ng-container *ngIf="craftingStation">
            <ng-container *ngFor="let material of item.material; trackBy:trackByIndex;">
                <div class="newrow" *ngIf="material.craftRequirement">
                    <span>
                        <strong>Craft Requirement&nbsp;</strong>
                        <span>{{material.craftRequirement}}</span>
                    </span>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="item.material && item.constructor.name === 'Weapon'">
        <div class="newrow">
            <strong>Material</strong>
            <select [(ngModel)]="newWeaponMaterial[0]" (ngModelChange)="add_WeaponMaterial()">
                <ng-container
                    *ngFor="let material of get_InitialWeaponMaterials(); let initialRuneIndex = index; trackBy:trackByIndex;">
                    <option [ngValue]="material" *ngIf="initialRuneIndex === 0" [selected]=!item.material[0]>
                        <!--Blank option to deselect-->
                    </option>
                    <optgroup *ngIf="initialRuneIndex === 1" label="Current material">
                        <option [ngValue]="material">
                            {{material.material.name}}
                        </option>
                    </optgroup>
                </ng-container>
                <optgroup label="Available materials" *ngIf="get_WeaponMaterials().length">
                    <option *ngFor="let material of get_WeaponMaterials(); trackBy:trackByIndex;" [ngValue]="material"
                        [disabled]="material.disabled" title="{{get_Title(material.material)}}">
                        {{material.material.name}}
                    </option>
                </optgroup>
            </select>
        </div>
        <ng-container *ngIf="craftingStation">
            <ng-container *ngFor="let material of item.material; trackBy:trackByIndex;">
                <div class="newrow" *ngIf="material.craftRequirement">
                    <span>
                        <strong>Craft Requirement&nbsp;</strong>
                        <span>{{material.craftRequirement}}</span>
                    </span>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
